import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataService } from "src/app/shared/Services/data.service";
import { ToastrService } from "ngx-toastr";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import * as moment from "moment";
import { fileValidator } from "src/app/shared/Services/custom-validator";

@Component({
  selector: "app-ai-version",
  templateUrl: "./ai-version.component.html",
  styleUrls: ["./ai-version.component.scss"],
})
export class AIVersionComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  aiModelForm: FormGroup;
  submitted: boolean = false;
  currentPage = 1;
  itemsPerPage = 3;
  pageSize;
  loginRole: any = "";
  delVersion = "";
  isEdit: boolean = false;
  isAdd: boolean = false;
  formData = new FormData();
  folderName: any;
  delName:any;
  constructor(
    private modalService: NgbModal,
    private dataService: DataService,
    private toastr: ToastrService,
    public formBuilder: FormBuilder,
    private http: HttpClient
  ) {}
  versions: any = [];
  ngOnInit(): void {
    this.get();
    this.breadCrumbItems = [
      { label: "AI Model" },
      { label: "Dashboard", active: true },
    ];
  }

  createItem(data): FormGroup {
    return this.formBuilder.group(data);
  }
  response: any = [];
  get() {
    this.http
      .get(
        "https://k2-clustering-partcount.azurewebsites.net/api/manage_model?code=E2WcV56j24e5HBga1O_reutSQuimNoEBi9txFCgef5oxAzFug8VPyw=="
      )
      .subscribe(
        (res) => {
          if (res) {
            let response = JSON.parse(JSON.stringify(res));
            this.versions = response.reduce((acc, obj) => {
              const existingObj = acc.find((item) => item.aiModelName === obj.aiModelName);
              if (existingObj) {
                existingObj.aiModelName = obj.aiModelName;
                existingObj.name.push(obj.name);
                existingObj.lastModify.push(obj.lastModify);
              } else {
                acc.push({
                  aiModelName: obj.aiModelName,
                  version: obj.version,
                  name: [obj.name],
                  lastModify: [obj.lastModify],
                });
              }
              return acc;
            }, []);
          }
        },
        (error) => {
          this.toastr.error(error);
        }
      );
  }
  get files(): FormArray {
    return this.aiModelForm.get("files") as FormArray;
  }
  initializeForm() {
    this.aiModelForm = this.formBuilder.group({
      aiModelName: ["", [Validators.required]],
      version: ["", Validators.required],
      files: this.formBuilder.array([], [Validators.required, fileValidator]),
    });
  }
  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }
  openModalDelete(deletetemplate, data) {
    this.delName = data['aiModelName'];
    this.delVersion = data['version'];
    this.modalService.open(deletetemplate, { centered: true });
  }
  delete() {
    this.http
      .delete(
        `https://k2-clustering-partcount.azurewebsites.net/api/manage_model?aiModelName=${this.delName}&version=${this.delVersion}&code=E2WcV56j24e5HBga1O_reutSQuimNoEBi9txFCgef5oxAzFug8VPyw==`
      )
      .subscribe(
        (res) => {
          console.log(res, "res");
          this.modalService.dismissAll();
          this.get();
        },
        (error) => {
          this.toastr.error(error);
        }
      );
  }
  edit(item) {
    this.isEdit = true;
    this.initializeForm();
    if (item) {
      const { aiModelName, version } = item;
      this.aiModelForm.patchValue({
        aiModelName: aiModelName || "",
        version: version || "",
      });
      for (let i = 0; i < item?.name?.length; i++) {
        const file = item.name[i];
        this.files.push(this.formBuilder.control(file));
      }
      this.aiModelForm.get("version").disable();
      this.aiModelForm.get("aiModelName").disable();
    }
  }
  cancel() {
    this.isEdit = false;
    this.submitted = false;
    this.isAdd = false;
  }
  get type() {
    return this.aiModelForm.controls;
  }
  updateObj: any;

  save() {
    this.submitted = true;
      this.aiModelForm.enable();

    this.formData = new FormData();

    if (this.aiModelForm.status == "INVALID") {
      return;
    }

    console.log(this.files, "files");
    let aiModelName = this.aiModelForm.get("aiModelName").value;
    let filePromises = [];

    for (let i = 0; i < this.files.length; i++) {
      let file = this.files.at(i).value.file;
      let fileName = this.files.at(i).value.file["name"];

      let filePromise = new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = (event) => {
          let base64String = event.target.result;
          if (typeof base64String === "string") {
            base64String = base64String.replace(/^data:.+;base64,/, "");
            resolve({
              fileContent: base64String,
              fileName: fileName,
              version: this.aiModelForm.get("version").value,
              aiModelName: aiModelName,
              folderName: this.folderName
            });
          } else {
            reject("File could not be processed as a Base64 string.");
          }
        };
        reader.onerror = () => reject("File reading error.");
        reader.readAsDataURL(file);
      });

      filePromises.push(filePromise);
    }

    // Wait for all files to be processed before calling the API
    if(this.isEdit == false){
      Promise.all(filePromises)
        .then((files) => {
          console.log(files, "Processed files");

          return this.http
            .post(
              "https://k2-clustering-partcount.azurewebsites.net/api/manage_model?code=E2WcV56j24e5HBga1O_reutSQuimNoEBi9txFCgef5oxAzFug8VPyw==",
              files
            )
            .toPromise();
        })
        .then((res) => {
          console.log(res, "postapi");
          this.get();
          this.submitted = false;
          this.initializeForm();
          this.isEdit = false;
          this.isAdd = false;
        })
        .catch((error) => {
          console.log(error);
          const errorMessage = error.error.split("\n")[0];
          this.toastr.error(errorMessage);
        });
    }else{
      Promise.all(filePromises)
      .then((files) => {
        console.log(files, "Processed files");

        return this.http
          .put(
            "https://k2-clustering-partcount.azurewebsites.net/api/manage_model?code=E2WcV56j24e5HBga1O_reutSQuimNoEBi9txFCgef5oxAzFug8VPyw==",
            files
          )
          .toPromise();
      })
      .then((res) => {
        console.log(res, "postapi");
        if(res){

          this.get();
          this.submitted = false;
          this.initializeForm();
          this.isEdit = false;
          this.isAdd = false;
        }
      })
      .catch((error) => {
        console.log(error);
        const errorMessage = error.error.split("\n")[0];
        this.toastr.error(errorMessage);
        this.aiModelForm.get("version").disable();
        this.aiModelForm.get("aiModelName").disable();
      });
    }
  }


  format(date) {
    return moment(date).format("DD/MM/YY HH:mm:ss a");
  }
  addAiModel() {
    this.isAdd = true;
    this.initializeForm();
  }

  fileInputChange(event) {
    let arrayoffiles = event.target.files;
    let firstFilePath = arrayoffiles[0].webkitRelativePath;
    this.folderName = firstFilePath.split("/")[0];
    while (this.files.length !== 0) {
      this.files.removeAt(0);
    }
    this.submitted = false;
    if (arrayoffiles) {
      for (let file of arrayoffiles) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.files.push(
            this.createItem({
              file,
            })
          );
        };
        reader.readAsDataURL(file);
      }
    }
  }
  showFiles(control) {
    let fileName;
    fileName =
      typeof control.value == "object"
        ? control.value.file.name
        : control.value;
    let maxLength = 15;
    if (fileName.length <= maxLength) {
      return fileName;
    }

    const extension = fileName.split(".").pop();
    const truncatedName = fileName.substring(0, maxLength - 3);
    return `${truncatedName}...${extension}`;
  }
  removeFile(index) {
    this.files.removeAt(index);
  }
}
